export function HeroSection() {
  return (
    <section className="hero-section" aria-labelledby="hero-heading">
      <div className="hero-section__inner">
        <h1 id="hero-heading" className="hero-section__title fade-in">
          An Archive Against Erasure.
        </h1>
        <p className="hero-section__subline fade-in fade-in--delay-1">
          Preserving identity through evidence, for memory and accountability.
        </p>
      </div>
    </section>
  );
}
